import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Photo } from '@/types/profile';
import { Spiner } from '@/ui-kit';

import styles from './gallery-image.module.scss';

type Props = {
    className?: string;
    image: Photo;
    imgStyle?: React.CSSProperties;
};

const GalleryImage: React.FC<Props> = ({
    className,
    image,
    imgStyle = {},
}) => {
    const [isLoading, setIsLoading] = useState(true);

    const imageUrl = image?.main_url;
    const imageName = image?.metadata?.filename;

    useEffect(() => {
        if (!imageUrl) handleStopLoading();
    }, [imageUrl]);

    const handleStopLoading = () => {
        setIsLoading(false);
    };

    return (
        <div className={clsx(className, styles.wrapper)}>
            {isLoading && (
                <div className={styles.preloader}>
                    <Spiner />
                </div>
            )}

            {imageUrl ? (
                <img
                    src={imageUrl}
                    alt={imageName}
                    loading="lazy"
                    style={imgStyle}
                    onLoad={handleStopLoading}
                    onError={handleStopLoading} />
            ) : (
                // todo: нужна заглушка для отсутствующего изображения профиля
                <div className={styles.preloader} />
            )}
        </div>
    );
};

export default GalleryImage;
